<div class="content">
  <form class="status-form" [formGroup]="updateForm" (ngSubmit)="onSubmitForm()">
    <div class="document" *ngFor="let fp of family.patients; let i = index;">
      <div class="document-content">
        <div class="document-avatar" [style.background-color]="getColorFromName(getInitial(fp.patient))">
          <img *ngIf="fp.patient?.photoUrl" [src]="fp.patient.photoUrl" alt="{{getFriendlyName(fp.patient)}}" class="avatar-img"/>
          <span *ngIf="!fp.patient?.photoUrl">{{getInitial(fp.patient)}}</span>
        </div>
        <div class="document-text">
          <div class="document-name">{{getFriendlyName(fp.patient)}}</div>
          <div class="document-desc">({{fp.relationship.replaceAll('_', ' ') | titlecase}}) {{sanitizeIdentifier(fp.patient.identifier)}}</div>
          <div><patient-tags [sourceTags]="fp.patient.tags" [entityId]="fp.patient.id" [context]="'PATIENT'"></patient-tags></div> 
        </div>
      </div>
      <div class="field">
        <mat-form-field>
          <mat-select class="ckl-item" name="status" [formControl]="getControl(i, 'status')" >
            <mat-option *ngFor="let status of familyPatientStatuses" [value]="status">{{status.replaceAll('_', ' ') | titlecase}}</mat-option>
          </mat-select>
         
        </mat-form-field>
        <div *ngIf="isConsented(fp.patient)">(Consented)</div>
        <div *ngIf="!isConsented(fp.patient)">(Not Consented)</div>
      </div> 
      <div class="field">
      <mat-form-field class="notes-field">
          <textarea matInput [formControl]="getControl(i, 'notes')" name="notes" placeholder="Add some notes" rows="4" columns="40" maxlength="255"></textarea>
      </mat-form-field>
      </div>
      <div class="action-buttons">
        <button  (click)="editPatient(fp.patient)" mat-icon-button >
          <mat-icon>edit_outline</mat-icon>
        </button>
        <button  (click)="goToPatient(fp.patient)" mat-icon-button >
          <mat-icon>arrow_forward_ios</mat-icon>
        </button>
      </div>

    </div>
    <div class="button-container">
      <button mat-flat-button color="primary" type="submit">
        Update
      </button>
    </div>
    <br><br><br><br><br><br><br><br><br><br><br><br><br><br>
<div class="add-new-container">
  <button mat-fab color="primary" type="button" (click)="editFamilyPatients()">
 + Add new
  </button>
</div>